import ReactGA from 'react-ga4';

export default function PageTracking() {
  ReactGA.initialize('G-RB1MYK83V3', { gaOptions: { cookieFlags: "SameSite=None;Secure" } });
  
  return null;
}